<template>
    <div>
        <div class="open-bjh-content">
            <div v-if="authenticationStatus && authenticationStatus < 7" class="error-page">
                <div class="img auth-img"></div>
                <div class="line">
                    <span class="icon-info"></span
                    >您还未完成律师资质认证，请先完成资质认证后再开通百家号
                </div>
                <div class="button" @click="goVerify">立即认证资质</div>
            </div>
            <div v-else-if="status === 'audit'" class="error-page">
                <div class="img err-img"></div>
                您的百家号账号开通申请审核中，如有疑问请联系客服
                <div class="button" @click="goFeedback">联系客服</div>
                <div class="link" @click="goFeedback">开通账号常见问题</div>
            </div>
            <template v-else>
                <veui-loading
                    v-if="isLoading"
                    :loading="true"
                    ui="strong l"
                >
                    加载中
                </veui-loading>
                <div v-else-if="!checkPass || isErrorStatus" class="error-page">
                    <div class="img err-img"></div>
                    您当前账号为非个人类型百家号或账号状态存在异常，请联系百家号确认
                    <div class="button" @click="goFeedback">联系客服</div>
                    <div class="link" @click="goQA">开通账号常见问题</div>
                </div>
                <bjh-form v-else></bjh-form>
            </template>
        </div>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @author sunxiaofeng01
 * @desc 我的首页-百家号开号
 */
import { mapState } from 'vuex';
import bjhForm from './bjh-form';
import lawLinkUrl from '@/components/law-bjh-tip/lawLinkUrl';
import { pageChange } from '@/utils/util';
import {Loading} from 'veui';

export default {
    name: 'bjhRegister',
    components: {
        bjhForm,
        'veui-loading': Loading
    },
    computed: {
        ...mapState({
            bjhInfo: (state) => state.lawStore.bjhInfo || {},
            authenticationStatus: (state) =>
                state.lawStore.authenticationStatus
        }),
        status() {
            return (
                (this.bjhInfo.bjh_info && this.bjhInfo.bjh_info.status) ||
                'null'
            );
        },
        isErrorStatus() {
            return !['null', 'pass'].includes(this.status);
        }
    },
    data() {
        return {
            checkPass: true,
            isLoading: true
        };
    },
    mounted() {
        this.checkBjh();
    },
    methods: {
        checkBjh() {
            this.$http.get('/bp/api/bjh/CheckIDCardByUID').then((res) => {
                if (res.data && +res.code === 0) {
                    this.checkPass =
                        +res.data.individual !== 1 &&
                        +res.data.organization !== 1;
                }
                this.$wywLog.send({
                    serverId: 16940,
                    area: 'page-pv',
                    action: 'show',
                    status: this.status
                });
            }).finally(() => {
                this.isLoading = false;
            });
        },
        // 去完成认证
        goVerify() {
            const isEdit = this.authenticationStatus === 1;
            this.$router.push({
                name: 'material',
                query: {
                    from: 'lawverifyguide',
                    ...(isEdit && {
                        isEdit: 'edit'
                    })
                }
            });
        },
        goFeedback() {
            pageChange({
                type: 'newtab',
                url: lawLinkUrl.bjhError
            });
        },
        goQA() {
            pageChange({
                type: 'newtab',
                url: lawLinkUrl.bjhQA
            });
        }
    }
};
</script>

<style lang="less" scoped>
.open-bjh-breadcrumb {
    margin-left: 24px;
}

.open-bjh-content {
    width: 100%;
    height: 100%;
    overflow: auto;
    padding: 24px;
    border-radius: 4px;
    background: #fff;
    position: relative;

    .veui-loading {
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translateX(-50%);
    }

    .error-page {
        margin-top: 64px;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #666666;
        font-weight: 500;

        .img {
            width: 357px;
            height: 223px;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: center;
            margin-bottom: 16px;

            &.auth-img {
                background-image: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/bjh-register/auth-img.png");
            }

            &.err-img {
                background-image: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/bjh-register/err-img.png");
            }
        }

        .line {
            display: flex;
            align-items: center;
        }

        .icon-info {
            margin-right: 14px;
            width: 24px;
            height: 24px;
            background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/bjh-register/icon-info.png")
                no-repeat center / cover;
        }

        .button {
            cursor: pointer;
            margin-top: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 21px;
            height: 40px;
            background: #336cff;
            border-radius: 5px;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #ffffff;
            font-weight: 500;
        }

        .link {
            cursor: pointer;
            margin-top: 12px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #0052cc;
            font-weight: 400;
        }
    }
}
</style>